/* eslint-disable max-statements */
import { Button, Divider, LoadingOverlay } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useState } from 'react';

import { SortDirection } from '@e-origin/shared';

import { InviteOnline, SearchBox, Table } from '@components';
import { ContentLayout } from '@features/layout';
import { useImporters, useImportersMeta } from '@hooks/importer';
import { useSettings } from '@hooks/useSettings';
import { useImporterListColumns } from './useImporterListColumns';

export const ImporterList = () => {
  const columns = useImporterListColumns();

  const { data: settings } = useSettings();

  const [criteria, setCriteria] = useState({
    filters: {
      searchQuery: '',
    },
    pagination: {
      page: 1,
      size: 10,
    },
    sorting: {
      field: 'createdAt',
      direction: SortDirection.DESC,
    },
  });

  const { data: importersList, isLoading } = useImporters(criteria);
  const { data: importersMeta } = useImportersMeta(criteria.filters);

  const handleSearch = (searchQuery: string) => {
    setCriteria({
      ...criteria,
      filters: {
        ...criteria.filters,
        searchQuery,
      },
    });
  };

  const handlePagination = (page: number, size: number) => {
    setCriteria({
      ...criteria,
      pagination: {
        page,
        size,
      },
    });
  };

  const openInviteOnline = () => {
    modals.open({
      title: 'Invite online seller',
      children: <InviteOnline onHide={modals.closeAll} />,
    });
  };

  if (!importersList) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <ContentLayout>
      <ContentLayout.Header>
        <ContentLayout.Title>Importers</ContentLayout.Title>
        <ContentLayout.Filters>
          {settings.isForwarder && (
            <Button data-pw="signUp-submit-btn" type="submit" variant="filled" size="lg" onClick={openInviteOnline}>
              Invite online seller
            </Button>
          )}
          <SearchBox handleSearch={handleSearch} placeholder="Search " />
        </ContentLayout.Filters>
      </ContentLayout.Header>
      <ContentLayout.Content>
        <Table columns={columns} dataSource={importersList ?? []} total={importersMeta.total} onPaginationChange={handlePagination} isLoading={isLoading} />
      </ContentLayout.Content>
      <Divider my="lg" />
    </ContentLayout>
  );
};
